export const preferredWritingStyleOptions: { value: string; label: string }[] = [
	{
		value: "businessCasual",
		label: "Business Casual",
	},
	{
		value: "businessProfessional",
		label: "Business Professional",
	},
	{
		value: "casual",
		label: "Casual",
	},
	{
		value: "formal",
		label: "Formal",
	},
];
